import detailController from './detailController';
import cartController from './cartController';
import orderConfirmController from './orderConfirmController';
import orderListController from './orderListController';
import orderDetailController from './orderDetailController';
import indexController from './indexController';
import errorController from './errorController';
import checkstandController from './checkstandController';
import applyRefundController from './applyRefundController';
import applyRefundStatusController from './applyRefundStatusController';
import applyRefundResultController from './applyRefundResultController';
import cooperIndexController from './cooperIndexController';
import cooperCashController from './cooperCashController';
import evaluateController from './evaluateController';
import searchController from './searchController';
import groupBuyingJumpController from './groupBuyingJumpController';
import orderCodSuccessController from './orderCodSuccessController';

export default {
    detailController,
    cartController,
    orderConfirmController,
    orderListController,
    orderDetailController,
    indexController,
    errorController,
    checkstandController,
    applyRefundController,
    applyRefundStatusController,
    applyRefundResultController,
    cooperIndexController,
    cooperCashController,
    evaluateController,
    searchController,
    groupBuyingJumpController,
    orderCodSuccessController
};



// WEBPACK FOOTER //
// ./src/js_modules/controllers.js